/** Main document workspace ("new document"). Public marketing site root is `/`. */
export const APP_WORKSPACE_PATH = '/app' as const;

export const APP_SIGNATURES_PATH = '/app/signatures' as const;
export const APP_RECENT_PATH = '/app/recent' as const;
export const APP_WORKFLOWS_PATH = '/app/workflows' as const;
export const APP_FOLDERS_PATH = '/app/folders' as const;
export const APP_STARRED_PATH = '/app/starred' as const;
export const APP_ARCHIVED_PATH = '/app/archived' as const;
export const APP_TRASH_PATH = '/app/trash' as const;
export const APP_SETTINGS_PATH = '/app/settings' as const;

export function conversationWorkspacePath(conversationId: string): string {
  return `/app/conversations/${conversationId}`;
}

export function folderDetailPath(folderId: string): string {
  return `/app/folders/${folderId}`;
}

/** Matches Auth "Continue without account" — also used for marketing logo when onboarding is done but there is no session. */
export const GUEST_APP_ENTRY_PATH = '/app' as const;
